import { render, staticRenderFns } from "./goback-info.vue?vue&type=template&id=48624aa2&scoped=true&"
import script from "./goback-info.vue?vue&type=script&lang=js&"
export * from "./goback-info.vue?vue&type=script&lang=js&"
import style0 from "./goback-info.vue?vue&type=style&index=0&id=48624aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48624aa2",
  null
  
)

export default component.exports